import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleToggle = () => setOpen((o) => !o);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <button className="burger" aria-label="Ouvrir le menu" onClick={handleToggle}>
        <span className="burger-bar" />
        <span className="burger-bar" />
        <span className="burger-bar" />
      </button>
      <ul className={open ? "open" : ""}>
        <li>
          <NavLink to="/" end onClick={handleClose}>ACCUEIL</NavLink>
        </li>
        <li>
          <NavLink to="/about" onClick={handleClose}>QUI SOMMES-NOUS</NavLink>
        </li>
        <li>
          <NavLink to="/services" onClick={handleClose}>SERVICES</NavLink>
        </li>
        <li>
          <NavLink to="/tarifs" onClick={handleClose}>TARIFS</NavLink>
        </li>
        <li>
          <NavLink to="/publications" onClick={handleClose}>BLOG</NavLink>
        </li>
        <li>
          <NavLink to="/careers" onClick={handleClose}>CARRIÈRES</NavLink>
        </li>
        <li>
          <NavLink to="/contact" onClick={handleClose}>CONTACT</NavLink>
        </li>
        <li>
          <NavLink to="/devis" className="nav-cta" onClick={handleClose}>Devis gratuit</NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
